







































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ResumeHeader from "@/components/resume/ResumeHeader.vue";
import ResumeSummary from "@/components/resume/ResumeSummary.vue";
import ResumeCertifications from "@/components/resume/ResumeCertifications.vue";
import ResumeProjects from "@/components/resume/projects/ResumeProjects.vue";
import ResumeWorkHistory from "@/components/resume/ResumeWorkHistory.vue";
import ResumeEducation from "@/components/resume/ResumeEducation.vue";
import { resumeService } from "@/components/resume/resumeService";

@Component({
    components: {
        ResumeHeader,
        ResumeSummary,
        ResumeCertifications,
        ResumeProjects,
        ResumeWorkHistory,
        ResumeEducation
    }
})
export default class Resume extends Vue {
    public openSource = resumeService.openSource;
    public closedSource = resumeService.closedSource;
}
